import React from 'react';
import { UrgencyBar } from '../components/sales/UrgencyBar';
import { HeroSection } from '../components/sales/HeroSection';
import { PainSection } from '../components/sales/PainSection';
import { RevealSection } from '../components/sales/RevealSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { OfferSection } from '../components/sales/OfferSection';
import { FAQSection } from '../components/sales/FAQSection';
import { GuaranteeSection } from '../components/sales/GuaranteeSection';
import { CloseSection } from '../components/sales/CloseSection';
import { Footer } from '../components/sales/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#0a0a0a] text-gray-200 font-sans selection:bg-indigo-500/30 selection:text-white" data-id="element-150">
      <UrgencyBar data-id="element-151" />

      <main className="pt-[60px] md:pt-[48px]" data-id="element-152">
        {' '}
        {/* Offset for sticky urgency bar */}
        <HeroSection data-id="element-153" />
        <PainSection data-id="element-154" />
        <RevealSection data-id="element-155" />
        <TestimonialsSection data-id="element-156" />
        <OfferSection data-id="element-157" />
        <FAQSection data-id="element-158" />
        <GuaranteeSection data-id="element-159" />
        <CloseSection data-id="element-160" />
      </main>
      <Footer data-id="element-161" />
    </div>;
}